import { Icon } from '@components/icon.component';
import { SquareButton } from '@components/square_button.component';
import { rem } from '@visiba/std';
import styled from 'styled-components';

interface Props {
	Component: React.FC;
	removeFn: () => void;
}

const elements = {
	information: styled.div`
		padding: ${rem(20)} ${rem(30)};
		background: #5e646e;
		color: white;
		display: flex;
		justify-content: space-between;
		align-items: center;
	`,
	content: styled.div`
		display: flex;
		justify-content: start;
		align-items: center;
	`,
	close: styled(SquareButton)`
		height: ${rem(32)};
		width: ${rem(32)};
		color: #e5e8f0;
		font-size: ${rem(13.5)};

		:hover,
		:active,
		:focus {
			background-color: #4c515a;
		}
	`,
	icon: styled.div`
		margin-right: ${rem(10)};

		svg {
			font-size: ${rem(24)};
			color: transparent; // Do not want stroke here
		}
	`,
};

export function InformationBanner({ Component, removeFn }: Props): JSX.Element {
	return (
		<elements.information>
			<elements.content>
				<elements.icon>
					<Icon type='warning' />
				</elements.icon>
				<Component />
			</elements.content>
			<elements.close
				data-testid='close_banner'
				icon='cross'
				onClick={() => {
					removeFn();
				}}
			/>
		</elements.information>
	);
}
